import styled from '@emotion/styled';

export const WebhookEventTypesConfig = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
`;
